export default "__VITE_ASSET__fZAvYmCa__"